import React, { useState, useEffect } from 'react'
import {
  Table as MuiTable,
  TableBody,
  TableCell,
  TableContainer,
  TableHead,
  TableRow,
  Paper,
  Box,
  TablePagination,
} from '@mui/material'
import Row from './Row'
import { LoadingSkeletonRows } from '../shared/LoadingSkeletonRows'
import ErrorMessage from '../../component/shared/component/ErrorMessage'
import { useGetLuckyDraws, useGetLuckyDrawSources } from '../../api/lucky-draw'

// Per-group caps live on the groups; this is the draw-wide one.
// The four trailing blanks are the draw, export, edit and delete action cells.
const COLUMNS = ['Draw', 'Source', 'Max Per Dealer', 'Prizes', '', '', '', '']

const Table = ({ searchKey }) => {
  const [page, setPage] = useState(0)
  const [rowsPerPage, setRowsPerPage] = useState(10)

  const { data, isLoading, refetch, error } = useGetLuckyDraws({
    page: page + 1,
    limit: rowsPerPage,
    searchKey,
  })
  const { data: sources = [] } = useGetLuckyDrawSources()

  const handleChangePage = (event, newPage) => setPage(newPage)

  const handleChangeRowsPerPage = (event) => {
    setRowsPerPage(+event.target.value)
    setPage(0)
  }

  useEffect(() => setPage(0), [searchKey])

  return (
    <Box>
      {error ? (
        <ErrorMessage error={error} onRetry={refetch} />
      ) : data?.docs?.length > 0 || isLoading ? (
        <>
          <TableContainer component={Paper}>
            <MuiTable>
              <TableHead>
                <TableRow>
                  {COLUMNS.map((column, index) => (
                    <TableCell key={index}>{column}</TableCell>
                  ))}
                </TableRow>
              </TableHead>
              <TableBody>
                {isLoading ? (
                  <LoadingSkeletonRows rows={10} length={COLUMNS.length} />
                ) : (
                  data.docs.map((row) => (
                    <Row key={row.id} data={row} sources={sources} refetch={refetch} />
                  ))
                )}
              </TableBody>
            </MuiTable>
          </TableContainer>
          {!isLoading && (
            <TablePagination
              component='div'
              count={data.totalDocs || 0}
              page={page}
              onPageChange={handleChangePage}
              rowsPerPage={rowsPerPage}
              onRowsPerPageChange={handleChangeRowsPerPage}
            />
          )}
        </>
      ) : (
        <ErrorMessage empty message='No lucky draws yet. Create one to get started.' />
      )}
    </Box>
  )
}

export default Table
